import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const getBankDetail = createAsyncThunk(
  "getBankDetail/getBankDetail",
  async (payload, thunkAPI) => {
    try {
     
      const response = await api.get(`bank/${payload.user_id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const getBankDetailSlice = createSlice({
  name: "getBankDetail",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBankDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBankDetail.fulfilled, (state, action) => {
          

        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getBankDetail.rejected, (state, action) => {
       
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default getBankDetailSlice.reducer;
